(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var params = new URLSearchParams(window.location.search);
    var isDownloadRequest = params.get('download') === 'true';
    var isCustomerPosted = params.get('customer_posted') === 'true';
    var isFormAnchor = window.location.hash === '#downloadFontForm';
    var hasFormErrors = document.querySelector('#downloadFontForm .form-status-list, #downloadFontForm .contact__field-error');

    var toggle = document.querySelector('[data-font-download-toggle]') || document.getElementById('toggle');
    var formWrap = document.querySelector('[data-font-download-form-wrap]');
    var success = document.querySelector('[data-font-download-success]') || document.querySelector('.font-success');

    function hidePurchaseUi() {
      document.querySelectorAll('.variant-picker, .product-form, .price').forEach(function (el) {
        el.style.display = 'none';
      });
    }

    if (isDownloadRequest || isCustomerPosted || isFormAnchor || hasFormErrors) {
      hidePurchaseUi();
    }

    if (isCustomerPosted) {
      if (toggle) toggle.style.display = 'none';
      if (formWrap) formWrap.style.display = 'none';
      if (success) success.style.display = '';
      return;
    }

    if (hasFormErrors || isFormAnchor) {
      if (toggle) toggle.style.display = 'none';
      if (formWrap) formWrap.style.display = '';
      return;
    }

    if (isDownloadRequest && toggle) {
      toggle.style.display = '';
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (formWrap) formWrap.style.display = '';
        toggle.style.display = 'none';
      });
    }
  });
})();
